import { Avatar, AvatarFallback } from "@/components/ui/avatar"
import { Badge } from "@/components/ui/badge"
import { Database } from '@/types/supabase-types';
import { EmployeeStatus, ResidencyType } from '@/contexts/employees/EmployeesContext';
import { StatusBadge } from "@/utils/statusUtils";

// Typed the employee prop based on the Supabase schema
type EmployeeRow = Database['ShiftSage']['Tables']['employees']['Row'];
interface ProfileHeaderProps {
  employee: Omit<
    EmployeeRow,
    'department'
  > & { department: string[] };
}

export function ProfileHeader({ employee }: ProfileHeaderProps) {
  // Generate initials safely
  const initials = `${employee.first_name?.charAt(0) || ''}${employee.last_name?.charAt(0) || ''}`.toUpperCase();

  return (
    <div className="flex flex-col items-center sm:flex-row sm:items-start gap-4">
      <Avatar className="h-24 w-24">
        {/* Use generated initials for fallback */}
        <AvatarFallback>{initials}</AvatarFallback>
      </Avatar>
      
      <div className="space-y-1 text-center sm:text-left">
        {/* Display first and last name */}
        <h2 className="text-2xl font-bold">{employee.first_name} {employee.last_name}</h2>
        <p className="text-muted-foreground">
          {/* Use optional chaining for potentially null values */}
          {employee.position || 'N/A'} • {employee.department || 'N/A'}
        </p>
        
        <div className="flex flex-wrap gap-2 justify-center sm:justify-start mt-2">
          <StatusBadge status={employee.status || EmployeeStatus.ACTIVE} />
          <Badge variant="outline">
            {/* Provide default value for residency */}
            {employee.residency || ResidencyType.RESIDENT}
          </Badge>
        </div>
      </div>
    </div>
  )
}
